var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 109,
    viewBox: "0 0 137 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.2501 39.54C71.8701 39.59 63.3601 39.2 55.4001 36.99C47.4401 34.78 40.4001 30.61 34.0001 25.74C29.8101 22.57 26.0001 20.05 20.5601 20.43C15.2411 20.7095 10.1535 22.6941 6.05009 26.09C-0.869909 32.15 0.180093 43.35 2.94009 51.23C7.10009 63.1 19.7601 71.34 30.5101 76.71C42.9401 82.92 56.5901 86.53 70.2801 88.6C82.2801 90.42 97.6901 91.75 108.08 83.91C117.63 76.72 120.25 60.28 117.91 49.18C117.341 45.9015 115.595 42.9433 113 40.86C106.29 35.96 96.2901 39.23 88.7501 39.4C86.0001 39.46 83.1101 39.53 80.2501 39.54Z",
    fill: "#3B0069",
    fillOpacity: 0.44
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3899 0.72998V5.02998",
    stroke: "#3B0069",
    strokeOpacity: 0.53,
    strokeWidth: 0.85,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.24 2.88H41.54",
    stroke: "#3B0069",
    strokeOpacity: 0.53,
    strokeWidth: 0.85,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.97 86.4399V90.7399",
    stroke: "#3B0069",
    strokeOpacity: 0.53,
    strokeWidth: 0.85,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.82 88.59H123.12",
    stroke: "#3B0069",
    strokeOpacity: 0.53,
    strokeWidth: 0.85,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89992 67.87C7.44116 67.87 7.87992 67.4313 7.87992 66.89C7.87992 66.3488 7.44116 65.91 6.89992 65.91C6.35868 65.91 5.91992 66.3488 5.91992 66.89C5.91992 67.4313 6.35868 67.87 6.89992 67.87Z",
    fill: "#3B0069",
    fillOpacity: 0.53
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3401 5.16996C90.8813 5.16996 91.3201 4.7312 91.3201 4.18996C91.3201 3.64872 90.8813 3.20996 90.3401 3.20996C89.7989 3.20996 89.3601 3.64872 89.3601 4.18996C89.3601 4.7312 89.7989 5.16996 90.3401 5.16996Z",
    fill: "#3B0069",
    fillOpacity: 0.53
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.18 108.04C83.4488 108.04 99.88 107.019 99.88 105.76C99.88 104.501 83.4488 103.48 63.18 103.48C42.9111 103.48 26.48 104.501 26.48 105.76C26.48 107.019 42.9111 108.04 63.18 108.04Z",
    fill: "#3B0069",
    fillOpacity: 0.44
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9101 12.41H88.2101C89.5362 12.41 90.8079 12.9368 91.7456 13.8745C92.6833 14.8122 93.2101 16.084 93.2101 17.41V80.82C93.2101 82.1461 92.6833 83.4179 91.7456 84.3556C90.8079 85.2933 89.5362 85.82 88.2101 85.82H28.0801C26.754 85.82 25.4822 85.2933 24.5445 84.3556C23.6069 83.4179 23.0801 82.1461 23.0801 80.82V24.36L34.9101 12.41Z",
    fill: "white",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.97 43.3101H38.01V86.4301H92.97V43.3101Z",
    fill: "#3B0069",
    fillOpacity: 0.51
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0801 24.36H32.7701C33.3386 24.3574 33.8829 24.1297 34.2839 23.7268C34.6849 23.3239 34.9101 22.7785 34.9101 22.21V12.41L23.0801 24.36Z",
    fill: "white",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7 29.54H38.34C36.2248 29.54 34.51 31.2548 34.51 33.37V45C34.51 47.1153 36.2248 48.83 38.34 48.83H92.7C94.8153 48.83 96.53 47.1153 96.53 45V33.37C96.53 31.2548 94.8153 29.54 92.7 29.54Z",
    fill: "white",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.07 42.55C46.9146 42.55 48.41 41.0546 48.41 39.21C48.41 37.3654 46.9146 35.87 45.07 35.87C43.2253 35.87 41.73 37.3654 41.73 39.21C41.73 41.0546 43.2253 42.55 45.07 42.55Z",
    fill: "#3B0069",
    fillOpacity: 0.51
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.57 42.55C57.4146 42.55 58.91 41.0546 58.91 39.21C58.91 37.3654 57.4146 35.87 55.57 35.87C53.7253 35.87 52.23 37.3654 52.23 39.21C52.23 41.0546 53.7253 42.55 55.57 42.55Z",
    fill: "#3B0069",
    fillOpacity: 0.51
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M66.06 42.55C67.9046 42.55 69.4 41.0546 69.4 39.21C69.4 37.3654 67.9046 35.87 66.06 35.87C64.2153 35.87 62.72 37.3654 62.72 39.21C62.72 41.0546 64.2153 42.55 66.06 42.55Z",
    fill: "#3B0069",
    fillOpacity: 0.51
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7 50.92H38.34C36.2248 50.92 34.51 52.6348 34.51 54.75V66.38C34.51 68.4953 36.2248 70.21 38.34 70.21H92.7C94.8153 70.21 96.53 68.4953 96.53 66.38V54.75C96.53 52.6348 94.8153 50.92 92.7 50.92Z",
    fill: "white",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45.07 63.94C46.9146 63.94 48.41 62.4446 48.41 60.6C48.41 58.7554 46.9146 57.26 45.07 57.26C43.2253 57.26 41.73 58.7554 41.73 60.6C41.73 62.4446 43.2253 63.94 45.07 63.94Z",
    fill: "#3B0069",
    fillOpacity: 0.51
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M55.57 63.94C57.4146 63.94 58.91 62.4446 58.91 60.6C58.91 58.7554 57.4146 57.26 55.57 57.26C53.7253 57.26 52.23 58.7554 52.23 60.6C52.23 62.4446 53.7253 63.94 55.57 63.94Z",
    fill: "#3B0069",
    fillOpacity: 0.51
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M66.06 63.94C67.9046 63.94 69.4 62.4446 69.4 60.6C69.4 58.7554 67.9046 57.26 66.06 57.26C64.2153 57.26 62.72 58.7554 62.72 60.6C62.72 62.4446 64.2153 63.94 66.06 63.94Z",
    fill: "#3B0069",
    fillOpacity: 0.51
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7 72.3101H38.34C36.2248 72.3101 34.51 74.0248 34.51 76.1401V87.7701C34.51 89.8853 36.2248 91.6001 38.34 91.6001H92.7C94.8153 91.6001 96.53 89.8853 96.53 87.7701V76.1401C96.53 74.0248 94.8153 72.3101 92.7 72.3101Z",
    fill: "white",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M45.07 85.32C46.9146 85.32 48.41 83.8246 48.41 81.98C48.41 80.1354 46.9146 78.64 45.07 78.64C43.2253 78.64 41.73 80.1354 41.73 81.98C41.73 83.8246 43.2253 85.32 45.07 85.32Z",
    fill: "#3B0069",
    fillOpacity: 0.51
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M55.57 85.32C57.4146 85.32 58.91 83.8246 58.91 81.98C58.91 80.1354 57.4146 78.64 55.57 78.64C53.7253 78.64 52.23 80.1354 52.23 81.98C52.23 83.8246 53.7253 85.32 55.57 85.32Z",
    fill: "#3B0069",
    fillOpacity: 0.51
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M66.06 85.32C67.9046 85.32 69.4 83.8246 69.4 81.98C69.4 80.1354 67.9046 78.64 66.06 78.64C64.2153 78.64 62.72 80.1354 62.72 81.98C62.72 83.8246 64.2153 85.32 66.06 85.32Z",
    fill: "#3B0069",
    fillOpacity: 0.51
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6199 53.8999C109.069 53.8999 118.35 44.6188 118.35 33.1699C118.35 21.7211 109.069 12.4399 97.6199 12.4399C86.171 12.4399 76.8899 21.7211 76.8899 33.1699C76.8899 44.6188 86.171 53.8999 97.6199 53.8999Z",
    fill: "white",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M112.34 48.21L117.86 53.73",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M117.243 51.0502L115.53 52.8428C114.759 53.6493 114.788 54.9279 115.594 55.6988L130.485 69.9336C131.291 70.7045 132.57 70.6757 133.341 69.8693L135.054 68.0766C135.825 67.2702 135.796 65.9915 134.99 65.2206L120.099 50.9859C119.293 50.215 118.014 50.2438 117.243 51.0502Z",
    fill: "white",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/NoData.7d2bf28c28930ea7004e109eabcd869c.svg";
export { ForwardRef as ReactComponent };